import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, InputLabel, DialogActions, Button, Autocomplete } from "@mui/material"
import { useEffect, useState } from "react";
import {updateCustomer} from "../../store/customers/customersSlice";
import {useDispatch} from "react-redux";
import JSDB from "fromKotlin/nk";
import { clientAutocompleteFilter, clientOptionLabel } from "../../utils/sort";

/** Next network id from all clients (active + inactive), matching backend getAllClient(false) max+1. */
const getNextBranchId = (): number => {
  try {
    const clients = JSDB().getAllClient(false)?.first?.toArray?.() ?? [];
    let maxBranch = 0;
    for (const client of clients) {
      const branch = Number(client?.branch ?? -1);
      if (branch > maxBranch) maxBranch = branch;
    }
    return maxBranch + 1;
  } catch {
    // Fallback if JSDB is unavailable — still prefer max from the passed branches list
    return 0;
  }
};

const branchClientFields = (branch: any) => {
  const master = JSDB().getClient(Number(branch?.master))?.first;
  return {
    id: branch?.master,
    name: branch?.name,
    externalId: master?.externalId ?? master?.external_id ?? master?.getExternalId?.(),
  };
};

const CreateBranchDialog = ({ chooseBranch, setChooseBranch, branches, params}) => {
  const dispatch = useDispatch();
  const [selectedBranch, setSelectedBranch] = useState<any>(null);
  const [isThereBranch, setIsThereBranch] = useState<boolean>(false);

  useEffect(() => {
    const focusedCell = params?.api?.getFocusedCell()
    const node = params?.api?.getDisplayedRowAtIndex(focusedCell?.rowIndex)
    if (node?.data?.nkObject?.branch >= 0) {
      setIsThereBranch(true)
    }
    if (!chooseBranch) {
      setSelectedBranch(null)
      setIsThereBranch(false)
    }
  }, [chooseBranch])

  return (
    <Dialog
      open={chooseBranch}
      onClose={() => {
        setChooseBranch(false)
        setSelectedBranch(null)
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {
          isThereBranch ?
            "ללקוח זה כבר קיימת רשת" :
            "בחר/ צור רשת"
        }
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <>
            <InputLabel style={{
              color: isThereBranch ? "red" : "black",
            }} id="demo-simple-select-label">
              {
                isThereBranch ?
                  "לא ניתן לשנות רשת" :
                  "בחר רשת"
              }
            </InputLabel>
            <Autocomplete
              disabled={isThereBranch}
              options={branches ?? []}
              value={selectedBranch}
              onChange={(_, value) => setSelectedBranch(value)}
              getOptionLabel={(option) => clientOptionLabel(branchClientFields(option))}
              isOptionEqualToValue={(a, b) => a?.branch === b?.branch}
              filterOptions={(options, { inputValue }) =>
                options.filter((branch) =>
                  clientAutocompleteFilter([branchClientFields(branch)], inputValue).length > 0
                )
              }
              renderInput={(params) => (
                <TextField {...params} label="בחר רשת" fullWidth />
              )}
              style={{ width: "100%" }}
              autoHighlight
            />
          </>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <>
          <Button onClick={() => setChooseBranch(false)}>בטל</Button>
          <Button disabled={isThereBranch || !selectedBranch} onClick={() => {
            const focusedRow = params?.api?.getFocusedCell()
            const rowNode = params?.api?.getDisplayedRowAtIndex(focusedRow?.rowIndex);

          console.log(params)
            dispatch(updateCustomer({
              ...rowNode.data,branch:selectedBranch.branch,master:selectedBranch.master
            }
          ))
            setChooseBranch(false)
          }}>שמור</Button>
          <Button
            disabled={isThereBranch || Boolean(typeof selectedBranch === "object" && selectedBranch?.name)}
            onClick={() => {
            const focusedRow = params?.api?.getFocusedCell()
            const rowNode = params?.api?.getDisplayedRowAtIndex(focusedRow?.rowIndex)

            const fromJsdb = getNextBranchId();
            const fromBranches = (branches ?? []).reduce(
              (max, branch) => (branch.branch > max ? branch.branch : max),
              0
            ) + 1;
            const nextBranch = Math.max(fromJsdb, fromBranches);

            dispatch(updateCustomer({
                  ...rowNode.data,branch: nextBranch, master:-1
                }
            ))
            setChooseBranch(false)
          }}>צור רשת חדשה</Button>
        </>
      </DialogActions>
    </Dialog>
  )
}

export default CreateBranchDialog
